module.exports = __webpack_public_path__ + "static/prodinity_full-f578a13cbb3bc00bf5c105a94df9bbd4.jpg";